import React, { useEffect, useRef, useState } from 'react';
import 'react-datepicker/dist/react-datepicker.css';
import { Button, Checkbox, Col, Form, Input, Modal, Row, DatePicker, Select, message, ConfigProvider } from 'antd';
import moment from "moment-timezone";
import axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarDays, faClock, faEnvelope, faPhone, faUserAlt } from '@fortawesome/free-solid-svg-icons';

const ScheduleCall = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [form] = Form.useForm();
    const [callNowChecked, setCallNowChecked] = useState(false);
    const [loading, setLoading] = useState(false);
    const [selectedDate, setSelectedDate] = useState(null);
    const [autoOpen, setAutoOpen] = useState(true);
    const autoOpenRef = useRef(autoOpen);

    const isOpenModel = () => {
        setIsOpen(true);
        setAutoOpen(false);
    }

    const isCloseModel = () => {
        setIsOpen(false);
        form.resetFields();
        setCallNowChecked(false);
        setSelectedDate(null);
    }

    useEffect(() => {
        autoOpenRef.current = autoOpen;
    }, [autoOpen]);

    useEffect(() => {
        const timer = setTimeout(() => {
            if (autoOpenRef.current) {
                isOpenModel();
            }
        }, 10000);

        return () => clearTimeout(timer);
    }, []);
    // Select Time In All Country

    const generateTimeOptionsIST = () => {
        const times = [];
        let start = moment.tz("2023-01-01 08:00", "Asia/Kolkata"); // IST
        const end = moment.tz("2023-01-01 20:00", "Asia/Kolkata"); // IST

        while (start <= end) {
            times.push(start.format("hh:mm A")); // show in 12-hour format
            start = start.clone().add(15, "minutes");
        }

        return times;
    };

    const timeOptions = generateTimeOptionsIST();



    const disabledDate = (current) => {
        // Get current date/time in IST
        const todayIST = moment.tz(moment(), "Asia/Kolkata").startOf("day");

        // Disable past dates & weekends (Saturday = 6, Sunday = 0)
        return (
            current < todayIST ||
            current.day() === 0 ||
            current.day() === 6
        );
    };

    const onFinish = async (values) => {
        setLoading(true);
        try {
            const payload = {
                name: values.name,
                mnumber: values.mnumber,
                email: values.email,
                call_now: values.call_now || false,
                date: values.date ? values.date.format('YYYY-MM-DD') : '',
                time: values.time || ''
            };

            console.log(payload);

            const response = await axios.post('https://tah.media/wp-content/themes/astra/build/send-email.php', payload);

            console.log(response.data);

            if (response.data.success) {
                alert('Call scheduled successfully!');
                form.resetFields();
                setIsOpen(false);
                setCallNowChecked(false);
                setSelectedDate(null);
            } else {
                message.error('Error: ' + response.data.message);
            }

        } catch (error) {
            console.error('Error submitting form', error);
        } finally {
            setLoading(false);
        }
    };



    return (
        <>

            <Button onClick={isOpenModel} className='fixed_call_button' icon={<img src='https://tah.media/wp-content/themes/astra/build/icon/call-white.png' alt="Call" className='button_icon' />}></Button>


            <ConfigProvider
            // theme={{
            //   algorithm: theme.darkAlgorithm,
            // }}
            >
                <Modal
                    open={isOpen}
                    footer={false}
                    width={400}
                    onCancel={isCloseModel}
                    className='call_sheduler_model'
                >
                    <h3 className='top-heading-for-call-shedule'>Schedule a call for your specific time</h3>
                    <Form
                        form={form}
                        name="call_shedule_form"
                        labelCol={{ span: 24 }}
                        wrapperCol={{ span: 24 }}
                        onFinish={onFinish}
                    >
                        <Row gutter={16}>
                            <Col span={24}>
                                <Form.Item
                                    label="Name"
                                    name="name"
                                    rules={[{ required: true, message: "Please enter your name!" }]}
                                >
                                    <Input placeholder="Name" prefix={<FontAwesomeIcon icon={faUserAlt} />} />
                                </Form.Item>
                            </Col>
                            <Col span={24}>
                                <Form.Item
                                    label="Phone number"
                                    name="mnumber"
                                    rules={[{ required: true, message: "Please enter your Phone Number!" }]}
                                >
                                    <Input placeholder="Phone number" prefix={<FontAwesomeIcon icon={faPhone} />} />
                                </Form.Item>
                            </Col>
                            <Col span={24}>
                                <Form.Item
                                    label="Email"
                                    name="email"
                                    rules={[{ required: true, message: "Please enter your Email!" }]}
                                >
                                    <Input placeholder="Email" prefix={<FontAwesomeIcon icon={faEnvelope} />} />
                                </Form.Item>
                            </Col>
                            <h3 className='top-heading-for-call-shedule' style={{ marginBottom: '0px', textAlign: 'center', width: '100%' }}>Pick your time for the callback</h3>
                            <Col span={24}>
                                <Form.Item
                                    name="call_now"
                                    valuePropName="checked"
                                >
                                    <Checkbox onChange={(e) => setCallNowChecked(e.target.checked)} >Call Now (You will receive a call in 6 minutes.) </Checkbox>
                                </Form.Item>
                            </Col>
                            {!callNowChecked && (
                                <>
                                    <Col span={14}>
                                        <Form.Item
                                            label="Date"
                                            name="date"
                                            rules={[{ required: true, message: "Select Date!" }]}
                                        >
                                            <DatePicker
                                                onChange={(e) => setSelectedDate(e?.format('YYYY-MM-DD'))}
                                                placeholder="Date"
                                                style={{ width: "100%" }}
                                                disabledDate={disabledDate}
                                                prefix={<FontAwesomeIcon icon={faCalendarDays} />}
                                            />
                                        </Form.Item>
                                    </Col>

                                    <Col span={10}>
                                        <Form.Item
                                            label="Time"
                                            name="time"
                                            rules={[{ required: true, message: "Select Time!" }]}
                                        >
                                            <Select disabled={!selectedDate} placeholder="Time" prefix={<FontAwesomeIcon icon={faClock} />}>
                                                {timeOptions.map((time) => {
                                                    const nowIST = moment.tz("Asia/Kolkata").add(15, "minutes");
                                                    const isToday = selectedDate && moment(selectedDate).isSame(nowIST, 'day');
                                                    const timeMoment = moment.tz(`2023-01-01 ${time}`, "YYYY-MM-DD hh:mm A", "Asia/Kolkata");

                                                    const isDisabled = isToday && timeMoment.isBefore(moment.tz("2023-01-01 " + nowIST.format("HH:mm"), "YYYY-MM-DD HH:mm", "Asia/Kolkata"));

                                                    return (
                                                        <Select.Option key={time} value={time} disabled={isDisabled}>
                                                            {time}
                                                        </Select.Option>
                                                    );
                                                })}
                                            </Select>
                                        </Form.Item>
                                    </Col>
                                </>
                            )}

                            <Col span={24}>
                                <Form.Item>
                                    <Button loading={loading} className='call_feature_submit_btn' type="primary" htmlType="submit">
                                        Schedule Call
                                    </Button>
                                </Form.Item>
                            </Col>

                        </Row>
                    </Form>
                </Modal>
            </ConfigProvider>

        </>
    );
};

export default ScheduleCall;
